import React from "react";
import MatchOfTheDayWrapper from "../../../../../dev/terminal/components/matchOfTheDayWrapper";
import Config from "../../../../../dev/config/main";
import {t} from "../../../../../dev/helpers/translator";
import {Link} from "react-router";
import FavoriteCompetitions from "../../../../../dev/terminal/components/favorteCompetitions";
import PopularSports from '../../../../../dev/terminal/components/popularSports';
import SecondPopularSports from "../../../../../dev/terminal/components/secondPopularSports";
import LiveGamesHompage from "../../../../../dev/terminal/components/liveGamesHompage";

export default function home2Template () {
    return <div className={`terminal-home v-${Config.homePageView}`}>
        <div className="popular-sports-w">
            <div className="title-f-games-r">
                <h2>Popular Games</h2>
            </div>
            <div className="sports-p-list">
                <PopularSports/>
                {Config.enableTopGames && <Link className="TopGames" to="/topGames/all/all" activeClassName="active"><i>{t("Top games")}</i></Link>}
            </div>
        </div>
        {Config.homePageView === 5 ? (
            <div className="live-now-menu">
            <div className="menu-list-v">
            <MatchOfTheDayWrapper/>
            </div>
                <LiveGamesHompage/>
        </div>) : (<div className="featured-games-w">
            <SecondPopularSports />
            </div>)
        }
        <div className="select-features-w">
            <div className="title-f-games-r">
                <h2>Select Features</h2>
            </div>
            <div className="product-list-wrapper-t">
                {
                    Config.headerItems.map((item, i) => {
                        return (item.name !== "Real Horse Racing" && item.name !== "Top Games") && <Link key={i} className={`prod-column-t ${item.url}`} to={`/${item.url}`} activeClassName="active">
                            {t(item.name)}
                        </Link>;
                    })
                }
            </div>
        </div>
        <div className="competitions-sports-w">
            <div className="title-f-games-r">
                <h2>Competitions</h2>
            </div>
            <div className="competitions-list-h">
                <FavoriteCompetitions/>
            </div>
        </div>
    </div>;
};